module.exports = __webpack_public_path__ + "static/media/logo-color.c19a2d35.png";